export const newsStories = [
    /* ================= NEWEST POSTS ON TOP ================ */
    // id is date (Year-Month-Day)
    // MarkUp #9
    {
        id: "2026-08-05",
        date: "8/5/2026",
        latestStory: true,
        title: "Thaea Mouratidis and Richie Joseph Earn 2025-26 BIG EAST Institutional Scholar-Athlete Awards",
        link: "https://friars.com/news/2026/8/5/general-thaea-mouratidis-and-richie-joseph-earn-2025-26-big-east-institutional-scholar-athlete-awards",
    },
    // MarkUp #10
    {
        id: "2026-08-04",
        date: "8/4/2026",
        latestStory: true,
        title: "Providence College Lands 286 Student-Athletes on 2025-26 BIG EAST All-Academic Team",
        link: "https://friars.com/news/2026/8/4/general-providence-college-lands-286-student-athletes-on-2025-26-big-east-all-academic-team",
    },
    // MarkUp #491
    {
        id: "2026-07-28",
        date: "7/28/2026",
        latestStory: true,
        title: "Athletics Chaplains",
        link: "https://news.providence.edu/athletics-chaplains/",
    },
    // MarkUp #492
    {
        id: "2026-07-06",
        date: "7/6/2026",
        latestStory: true,
        title: "Men's Ice Hockey, Men's and Women's Hockey Teams Combine for 41 Hockey East All-Academic Team Selections",
        link: "https://friars.com/news/2026/7/6/mens-ice-hockey-mens-and-womens-hockey-teams-combine-for-41-hockey-east-all-academic-team-selections",
    },
    {
        id: "2025-10-30",
        date: "10/30/2025",
        latestStory: true,
        title: "Friar Athletics Hosts Biennial Student-Athlete Career Night",
        link: "https://friars.com/news/2025/10/30/general-friar-athletics-hosts-biennial-student-athlete-career-night",
    },
    {
        id: "2025-09-16",
        date: "9/16/2025",
        latestStory: true,
        title: "Providence College Athletics Hosts Second Annual NIL Media Day, Presented By Opendorse",
        link: "https://friars.com/news/2025/9/16/general-providence-college-athletics-hosts-second-annual-nil-media-day-presented-by-opendorse",
    },
    {
        id: "2025-08-11",
        date: "8/11/2025",
        latestStory: true,
        title: "Providence College Well-Represented On BIG EAST All-Academic Team",
        link: "https://friars.com/news/2025/8/11/general-providence-college-well-represented-on-big-east-all-academic-team",
    },
    {
        id: "2025-05-23",
        date: "5/23/2025",
        latestStory: true,
        title: "Providence College Named Top-10 Finalist For The NACDA Community Service Award",
        link: "https://friars.com/news/2025/5/23/general-providence-college-named-top-10-finalist-for-the-nacda-community-service-award",
    },
    {
        id: "2025-07-18",
        date: "7/18/2025",
        latestStory: true,
        title: "Men's And Women's Basketball Teams Up With Providence Rec For A Free Youth Basketball Clinic Sponsored By Amica",
        link: "https://friars.com/news/2025/7/18/general-mens-and-womens-basketball-teams-up-with-providence-rec-for-a-free-youth-basketball-clinic-sponsored-by-amica",
    },
    {
        id: "2025-08-05",
        date: "8/5/2025",
        latestStory: true,
        title: "Ahnna Faust Nominated for Allstate NACDA Good Works Team",
        link: "https://friars.com/news/2025/8/5/womens-soccer-ahnna-faust-nominated-for-allstate-nacda-good-works-team",
    },
    {
        id: "2025-05-19",
        date: "5/19/2025",
        latestStory: true,
        title: "Two Providence College Student-Athletes Finish At The Top Of Their Class",
        link: "https://friars.com/news/2025/5/19/general-two-providence-college-student-athletes-finish-at-the-top-of-their-class",
    },
    {
        id: "2025-01-28",
        date: "1/28/2025",
        latestStory: true,
        title: "Providence College Athletics Hosts Chi Alpha Sigma Induction Ceremony",
        link: "https://friars.com/news/2025/1/28/general-providence-college-athletics-hosts-chi-alpha-sigma-induction-ceremony",
    },
    {
        id: "2025-01-14",
        date: "1/14/2025",
        latestStory: true,
        title: "Providence College Student-Athletes Post A Record Fall In The Classroom",
        link: "https://friars.com/news/2025/1/14/general-providence-college-student-athletes-post-a-record-fall-in-the-classroom",
    },
    /* ****************************************************** */
    /*                     HIDDEN STORIES                     */
    /* ****************************************************** */
    // *Remove latestStory tag
    {
        id: "2024-10-16",
        date: "10/16/2024",
        title: "NIL Media Day Story",
        link: "https://friars.com/news/2024/10/16/general-providence-college-athletics-hosts-nil-media-day-presented-by-opendorse.aspx",
    },
    {
        id: "2024-08-13",
        date: "8/13/2024",
        title: "Providence College well represented on 2023-2024 BIG EAST All-Academic Team",
        link: "https://friars.com/news/2024/8/13/general-two-hundred-sixty-one-student-athletes-named-to-big-east-all-academic-team.aspx",
    },
    {
        id: "2024-06-18",
        date: "6/18/2024",
        title: "Men's & Women's Hockey Programs Combine for 35 Hockey East All-Academic Team Selections",
        link: "https://friars.com/news/2024/6/18/mens-ice-hockey-mens-and-womens-hockey-combine-for-35-hockey-east-all-academic-team-selections",
    },
    {
        id: "2024-06-04",
        date: "6/4/2024",
        title: "The NCAA Releases Latest Academic Progress Rate Report Through The 2022-23 Season",
        link: "https://friars.com/news/2024/6/4/general-the-ncaa-releases-latest-academic-progress-rate-report-through-the-2022-23-season.aspx",
    },
    {
        id: "2024-04-22",
        date: "4/22/2024",
        title: "Providence College Hosts 63rd Annual All-Sports Gala",
        link: "https://friars.com/news/2024/4/22/general-athletic-department-hosts-63rd-annual-all-sports-gala.aspx",
    },
    {
        id: "2024-02-13",
        date: "2/13/2024",
        title: "Providence College Athletics announces 23-24 Chi Alpha Sigma Inductees",
        link: "https://friars.com/news/2024/2/13/general-athletic-department-hosts-chi-alpha-sigma-induction-ceremony.aspx",
    },
    {
        id: "2024-01-31",
        date: "1/31/2024",
        title: "Providence Athletics To Celebrate Black History Month With Month-Long Exhibition",
        link: "https://friars.com/news/2024/1/30/general-providence-athletics-to-celebrate-black-history-month-with-month-long-exhibition",
    },
    {
        id: "2023-08-08",
        date: "8/8/2023",
        title: "Two-Hundred Forty-Two Student Athletes Named To BIG EAST All-Academic Team",
        link: "https://friars.com/news/2023/8/8/general-two-hundred-forty-two-student-athletes-named-to-big-east-all-academic-team.aspx",
    },
    {
        id: "2023-05-05",
        date: "5/5/2023",
        title: "Providence College Athletics Finishes Eighth in NCAA Division I Community Service",
        link: "https://friars.com/news/2023/5/5/athletic-department-providence-college-athletics-finishes-eighth-in-ncaa-division-i-community-service.aspx",
    },
    {
        id: "2022-06-02",
        date: "6/2/2022",
        title: "PC Athletics finishes 14th in NCAA Division I Team Works Community Service Competition",
        link: "https://friars.com/news/2022/6/2/general-providence-college-athletics-finishes-14th-in-ncaa-division-i-team-works-community-service-competition",
    },
    {
        id: "2021-08-25",
        date: "8/25/2021",
        title: "Providence College Athletics Announces The Friar Edge",
        link: "https://friars.com/news/2021/8/25/general-providence-college-athletics-announces-the-friar-edge",
    },
    {
        id: "2021-08-04",
        date: "8/4/2021",
        title: "Providence College Launches AdvantEdge NIL Program Powered By Opendorse",
        link: "https://friars.com/news/2021/8/4/athletic-department-providence-college-launches-advantedge-nil-program-powered-by-opendorse",
    },
    {
        id: "2021-07-22",
        date: "7/22/2021",
        title: "Three Providence College Student-Athletes Honored As 2020-21 Sport Excellence Award Winners",
        link: "https://friars.com/news/2021/7/22/field-hockey-three-providence-college-student-athletes-honored-as-2020-21-sport-excellence-award-winners",
    },
    {
        id: "2021-07-21",
        date: "7/21/2021",
        title: "Providence College Well-Represented On 2020-21 BIG EAST All-Academic Team",
        link: "https://friars.com/news/2021/7/21/general-providence-college-well-represented-on-2020-21-big-east-all-academic-team",
    },
    {
        id: "2021-04-13",
        date: "4/13/2021",
        title: "A Look Back At Friars United Week",
        link: "https://friars.com/news/2021/4/13/general-a-look-back-at-friars-united-week",
    },
    {
        id: "2020-11-17",
        date: "11/17/2020",
        title: "Providence College Student-Athletes Post 97-percent Graduation Success Rate",
        link: "https://friars.com/news/2020/11/17/general-providence-college-student-athletes-post-97-percent-graduation-success-rate",
    },
    {
        id: "2020-09-29",
        date: "9/29/2020",
        title: "BIG EAST Student-Athlete Advisory Committee Launches Voter Registration Campaign",
        link: "https://friars.com/news/2020/9/29/general-big-east-student-athlete-advisory-committee-launches-voter-registration-campaign",
    },
    {
        id: "2020-04-30",
        date: "4/30/2020",
        title: "Providence College Athletics Finishes Fifth in NCAA Division I Team Works Community Service Competition",
        link: "https://friars.com/news/2020/4/30/general-providence-college-athletics-finishes-sixth-in-ncaa-division-i-team-works-community-service-competition",
    },
];
